import "./DiscussionContentContainer.scss";

export default {
  root: "im-discussion-content-container",
  content: "im-discussion-content-container__content",
  aside: "im-discussion-content-container__aside",
};
